import gql from 'graphql-tag';

// Comments v3 (spec 2026-10-18-comments-design, plan 1): a new comment or reply through the addComment action.
export default gql`
mutation addComment($object: AddCommentInput!) {
  addComment(object: $object) {
    ok
    error
    reason
    commentId
  }
}
`;
